import React from "react";
import { PopoverProps, Popover, makeStyles, Typography, Grid } from "@material-ui/core";
import CloseIconButton from "../components/CloseIconButton";
import { Theme } from "../.themes";

export interface PopupProps extends PopoverProps {
  title?: string;
  description?: string;
  footerDescription?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  popup: {
    flexDirection: "column",
    maxWidth: 508,
    minWidth: 508,
    [theme.breakpoints.down("sm")]: {
      minWidth: 300,
    },
    ...theme.popup?.root,
  },
  paper: {
    position: "relative",
  },
  popover: {
    background: "rgba(0,0,0,0.5)",
    maxWidth: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  h4: {
    color: theme.palette.text.primary,
    fontWeight: 700,
    ...theme.popup?.h4,
  },
  subtitle: {
    marginTop: 16,
    color: theme.palette.primary.main,
    fontWeight: 700,
  },
  rightAlign: {
    textAlign: "right",
  },
  header: {
    padding: `16px 32px`,
    background: "rgba(0,0,0,0.2)",
    [theme.breakpoints.down("sm")]: {
      padding: 16,
    },
    ...theme.popup?.headerBackground,
  },
  body: {
    padding: 32,
    [theme.breakpoints.down("sm")]: {
      padding: 16,
    },
  },
}));

const releaseKeys = ["Escape", "Tab", " "];

export const Popup: React.FC<PopupProps> = (props: PopupProps) => {
  const classes = useStyles();

  const handleClose = (event: any) => {
    if (props.onClose) {
      props.onClose(event, "escapeKeyDown");
    }
  };

  return (
    <Popover
      {...props}
      classes={{
        root: classes.popover,
        paper: classes.paper,
      }}
      anchorReference={"none"}
      onKeyDown={(e: any) => {
        if (releaseKeys.includes(e.key)) handleClose(e);
      }}
    >
      <div className={classes.popup}>
        <Grid container direction='row' className={classes.header}>
          <Grid item xs={10}>
            <Typography variant='h4' className={classes.h4}>
              {props.title || ""}
            </Typography>
          </Grid>
          <Grid item xs={2} className={classes.rightAlign}>
            <CloseIconButton onClick={event => handleClose(event)} />
          </Grid>
        </Grid>
        <Grid container direction='row' className={classes.body}>
          <Grid item xs={12}>
            {/* This is dangerous! Use only with trusted sources! 
                            We are receiving HTML string from CMS/Gadget here.*/}
            <Typography dangerouslySetInnerHTML={{ __html: props.description || "" }}></Typography>
          </Grid>
          {props.footerDescription && (
            <Grid item xs={12}>
              <Typography
                variant='subtitle2'
                className={classes.subtitle}
                dangerouslySetInnerHTML={{ __html: props.footerDescription || "" }}
              ></Typography>
            </Grid>
          )}
        </Grid>
      </div>
    </Popover>
  );
};

export default Popup;
